import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Dropdown, Flex, Modal, Row, Space, Switch } from "antd";
import TableAntd from "components/elements/Table";
import { MainLayout } from "components/layouts";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { formatDate } from "utils/formatter";
import { useSelector } from "react-redux";

const SettingTimesheetProject = (
    {
        pagination = {},
        dataSource = [],
        onPageChange = () => { },
        updateTimeSheetStatus = () => { },
        onEdit = () => { },
        onView = () => { },
        deleteStpTimeSheetById = () => { },
        isLoading = false,
    }
) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { roles } = useSelector((state) => state.company);

    const onDelete = (e) => {

        Modal.confirm({
            title: t('logout.Areyousure'),
            content: (
                <>
                    <p>{t('setting_project.message.delete')}</p>
                </>
            ),
            onOk() {
                deleteStpTimeSheetById(e)
            },
            okText: t('confirm-2'),
            cancelText: t('masterData.cancel'),
        });
    };

    const columns = useCallback(
        () => {
            return [
                {
                    title: <div className="text-table">{t('setting_project.label.projectId')}</div>,
                    dataIndex: "projectCode",
                    key: "projectCode",
                    align: "center"
                },
                {
                    title: <div className="text-table">{t('setting_project.label.projectName')}</div>,
                    dataIndex: "projectName",
                    key: "projectName",
                    render: (_, record) => {
                        return i18n.language === 'en' ? record?.projectNameEn : record?.projectName
                    }
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('start-date')}</div>,
                    dataIndex: "startDate",
                    key: "startDate",
                    align: "center",
                    render: (_, record) => {
                        return formatDate(record?.startDate)
                    }
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('end-date')}</div>,
                    dataIndex: "endDate",
                    key: "endDate",
                    align: "center",
                    render: (_, record) => {
                        return formatDate(record?.endDate)
                    }
                },
                {
                    title: <div className="text-table">{t('setting_project.label.projectMembers')}</div>,
                    dataIndex: "numberOfEmployee",
                    key: "numberOfEmployee",
                    align: "center"
                },
                {
                    title: <div className="text-table">{t('setting_project.label.workingDay')}</div>,
                    dataIndex: "manDay",
                    key: "manDay",
                    align: "center"
                },
                {
                    title: <div className="text-table">{t('setting_project.label.responsiblePerson')}</div>,
                    dataIndex: "ownerList",
                    key: "ownerList",
                    align: "center",
                    render: (_, record) => {
                        return i18n.language === 'en' ? record?.ownerLists?.[0]?.fullNameEn : record?.ownerLists?.[0]?.fullName
                    }
                },
                {
                    title: (
                        <div className="text-table" style={{ textAlign: "center" }}>{t("status.entity")}</div>
                    ),
                    dataIndex: "projectStatus",
                    key: "projectStatus",
                    align: "center",
                    width: 120,
                    render: (text, record) => {

                        return <Switch
                            checked={text === "ACTIVE" || record?.statusFlag === "Y" || record?.statusFlag === "ACTIVE"}
                            onChange={(checked) => updateTimeSheetStatus(checked, record)}
                        />
                    },
                },
                {
                    title: "",
                    key: "action",
                    align: "center",
                    width: "80px",
                    render: (_, record) => (
                        <Space size="middle">
                            <Dropdown
                                menu={{
                                    items: [
                                        {
                                            key: "1",
                                            onClick: () => onView(record),
                                            label: `${t("action.view")}`,
                                            icon: (
                                                <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                                            ),
                                        },
                                        roles.includes("UPDATE_SETTING_TIMESHEET|SETTING_PROJECT") && {
                                            key: "2",
                                            onClick: () => onEdit(record),
                                            label: `${t("action.edit")}`,
                                            icon: (
                                                <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                                            ),
                                        },
                                        roles.includes("DELETE_SETTING_TIMESHEET|SETTING_PROJECT") && {
                                            key: "3",
                                            onClick: () => onDelete(record),
                                            label: `${t("action.delete")}`,
                                            icon: (
                                                <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                                            ),
                                        }
                                    ],
                                }}
                            >
                                <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                            </Dropdown>
                        </Space>
                    ),
                }
            ]
        }, [i18n.language, updateTimeSheetStatus, roles])

    return (
        <MainLayout>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("setting_timesheet.header"), href: "" },
                        { title: t("setting_project.header") },
                    ]} />
                    <h2>{t("setting_project.header")}</h2>
                </Flex>

                {roles.includes("CREATE_SETTING_TIMESHEET|SETTING_PROJECT") && (
                    <Row justify={"end"}>
                        <Button
                            type="primary"
                            style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                            icon={<CreateIcon style={{ fontSize: 16 }} />}
                            onClick={() => {
                                navigate("/setting_timesheet/setting_project/create")
                            }}
                        >
                            {t("setting_project.label.create")}
                        </Button>
                    </Row>
                )}

                <TableAntd
                    columns={columns()}
                    dataSource={dataSource}
                    pagination={pagination}
                    onChange={onPageChange}
                    loading={isLoading}
                />
            </Space>
        </MainLayout>
    )
}

export default SettingTimesheetProject;